import List from './list/ReferralDeclineReasonListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List(),
})